import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
// ...existing code...
import BackgroundImages from './components/BackgroundImages/BackgroundImages';
import HomePage from './pages/HomePage';
import PostPage from './pages/PostPage';
import AdminLogin from './pages/AdminLogin';
import AdminPosts from './pages/AdminPosts';
import AdminPostEditor from './pages/AdminPostEditor';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* <BackgroundDecoration /> */}
          <BackgroundImages />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/post/:slug" element={<PostPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPosts />} />
            <Route path="/admin/posts/new" element={<AdminPostEditor />} />
            <Route path="/admin/posts/edit/:id" element={<AdminPostEditor />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
